import { useState, type FormEvent } from 'react';
import { loginWithPasskey, registerFirstPasskey, registerWithEnrollCode, browserSupportsWebAuthn } from '../lib/webauthn';
import { useAuth } from '../lib/auth';
import { Mark } from '../components/Mark';
import { Icon } from '../components/Icon';
import { ThemeToggle } from '../components/ThemeToggle';

function errorMessage(e: unknown): string {
  return e instanceof Error ? e.message : 'Errore imprevisto';
}

export function Login() {
  const { refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showSetup, setShowSetup] = useState(false);
  const [showEnroll, setShowEnroll] = useState(false);
  const [secret, setSecret] = useState('');
  const [label, setLabel] = useState('');
  const [code, setCode] = useState('');

  const supported = browserSupportsWebAuthn();

  async function onLogin() {
    setError(null);
    setBusy(true);
    try {
      await loginWithPasskey();
      refresh();
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  async function onSetup(ev: FormEvent) {
    ev.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await registerFirstPasskey(label.trim() || 'Questo dispositivo', secret.trim());
      await loginWithPasskey();
      refresh();
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  async function onEnroll(ev: FormEvent) {
    ev.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await registerWithEnrollCode(code.trim().toUpperCase(), label.trim() || 'Questo dispositivo');
      await loginWithPasskey();
      refresh();
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app">
      <header className="bar">
        <div className="spacer" />
        <ThemeToggle />
      </header>

      <main className="login-wrap">
        <div className="login-card">
          <div className="mark"><Mark /></div>
          <h1>2P&nbsp;<span className="ai">AI</span></h1>
          <div className="tag">CRM AI</div>

          {!supported && <p className="err">Questo browser non supporta le passkey (WebAuthn).</p>}
          {error && <p className="err">{error}</p>}

          <button className="btn-primary" type="button" onClick={() => void onLogin()} disabled={busy || !supported}>
            <Icon name="fingerprint" />
            {busy ? '…' : 'Accedi con passkey'}
          </button>

          <button className="btn-ghost" type="button" onClick={() => { setShowEnroll((v) => !v); setShowSetup(false); }} disabled={busy}>
            {showEnroll ? 'Annulla' : 'Ho un codice'}
          </button>

          <button className="btn-ghost" type="button" onClick={() => { setShowSetup((v) => !v); setShowEnroll(false); }} disabled={busy}>
            {showSetup ? 'Annulla' : 'Prima configurazione'}
          </button>

          {showEnroll && (
            <form className="setup" onSubmit={onEnroll}>
              <div className="field">
                <label>Codice di registrazione</label>
                <input
                  className="inp mono"
                  type="text"
                  autoComplete="off"
                  autoCapitalize="characters"
                  placeholder="XXXX-XXXX-XXXX-XXXX-XXXX"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                />
              </div>
              <div className="field">
                <label>Nome dispositivo</label>
                <input
                  className="inp"
                  type="text"
                  placeholder="Mac di Paolo"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                />
              </div>
              <button className="btn-primary" type="submit" disabled={busy || !supported}>
                Registra questo dispositivo
              </button>
            </form>
          )}

          {showSetup && (
            <form className="setup" onSubmit={onSetup}>
              <div className="field">
                <label>Bootstrap secret</label>
                <input
                  className="inp mono"
                  type="password"
                  autoComplete="off"
                  value={secret}
                  onChange={(e) => setSecret(e.target.value)}
                  required
                />
              </div>
              <div className="field">
                <label>Nome dispositivo</label>
                <input
                  className="inp"
                  type="text"
                  placeholder="iPhone di Paolo"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                />
              </div>
              <button className="btn-primary" type="submit" disabled={busy || !supported}>
                Registra la prima passkey
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
